/* NORTHSHEEP — card photos are there before the card is (owner, 2 Oct 2026:
   "the product images are loading a bit too slow on the collection page. like
   i see first white and they only load when they come in screen but maybe
   they have to already load a bit before so it doesnt look so laggy").

   The cards below the first rows are lazy: the browser fetches a photo once it
   decides the card is close, and how close is its own choice. Safari, which
   every iPhone browser is, leaves it late enough to show the white tile first.

   So the grid decides for itself. A card within two screens below the one in
   view (and half a screen above it, for a page restored halfway down) gets
   its photo and its colour dots switched to normal loading, and the photo is
   decoded ahead, so it is painted the moment it scrolls in. The second photo
   (the desktop hover picture) stays lazy. Cards that land later (the next
   batch, a filter, a sort) are picked up as they arrive.

   No setting: it changes WHEN a picture loads, never what is shown or at what
   quality. Data Saver is left alone. Used by the collection grid and the
   search results (both #product-grid). */
(function () {
  'use strict';
  if (window.__nsGridPreload) return;
  window.__nsGridPreload = true;
  if (!('IntersectionObserver' in window)) return;
  var conn = navigator.connection;
  if (conn && conn.saveData) return;

  var PICS = '.card__media .media > img:first-child, .ns-card-swatches img';

  function wake(card) {
    var imgs = card.querySelectorAll(PICS);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('loading') !== 'lazy') continue;
      img.setAttribute('loading', 'eager');
      if (i === 0 && img.decode) img.decode().catch(function () {});
    }
  }

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        io.unobserve(entries[i].target);
        wake(entries[i].target);
      }
    },
    { rootMargin: '50% 0px 200% 0px' }
  );

  function scan() {
    var cards = document.querySelectorAll('#product-grid > .grid__item');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].__nsPre) continue;
      cards[i].__nsPre = true;
      io.observe(cards[i]);
    }
  }

  var timer = 0;
  function later() {
    clearTimeout(timer);
    timer = setTimeout(scan, 60);
  }

  scan();
  /* The container survives a filter or a sort (Dawn replaces what is inside
     it), so one observer on it sees every new batch of cards. */
  var box = document.getElementById('ProductGridContainer');
  if (box && 'MutationObserver' in window) {
    new MutationObserver(later).observe(box, { childList: true, subtree: true });
  }
  document.addEventListener('ns:cards-appended', later);
})();
